$(function() {
    $('table.table-responsive').each(function() {
        $(this).wrap("<div class='table-responsive'></div>");
    });
});
